import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { useParams } from "react-router";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import Pagination from "../../Pagination";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";

const AuditTrial = ({ tableRef, onMouseDown }) => {
  const [activityLoader, setActivityLoader] = useState(false);
  const [EDCActivity, setEDCActivity] = useState([]);
  const [EDCActivityCount, setEDCActivityCount] = useState(0);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(EDCActivityCount / itemsPerPage);

  const getStudyAllCDISCAuditTrialList = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAllCDISCAuditTrialList(
      studyId,
      "all",
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setEDCActivity(data?.data || []);
    setEDCActivityCount(data?.count || 0);
    setActivityLoader(false);
  };
  useEffect(() => {
    getStudyAllCDISCAuditTrialList(pageNumber, itemsPerPage);
  }, [pageNumber, itemsPerPage]);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 147px)" }}
      >
        {activityLoader ? (
         <PageLoader/>
        ) : EDCActivity?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG="Activity not found" />
          </div>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th
                    style={{ width: 150 }}
                    onMouseDown={(e) => onMouseDown(e, 1)}
                  >
                    Activity Type
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Activities</th>
                  <th
                    style={{ width: 200 }}
                    onMouseDown={(e) => onMouseDown(e, 3)}
                  >
                    Previous Value
                  </th>
                  <th
                    style={{ width: 200 }}
                    onMouseDown={(e) => onMouseDown(e, 4)}
                  >
                    Updated Value
                  </th>
                  <th
                    style={{ width: 100 }}
                    onMouseDown={(e) => onMouseDown(e, 5)}
                  >
                    Activity By
                  </th>
                  <th
                    style={{ width: 130 }}
                    onMouseDown={(e) => onMouseDown(e, 6)}
                  >
                    Activity Date | Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {EDCActivity?.map((item, index) => (
                  <tr>
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td className="text-uppercase">{item?.actionType}</td>
                    <td>{item?.activities}</td>
                    <td>{item?.previousValue}</td>
                    <td>{item?.updatedValue}</td>
                    <td>{item?.activityBy}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={EDCActivityCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default AuditTrial;
